export const FETCH_ASSIGNMENT = 'FETCH_ASSIGNMENT';
export const FETCH_ASSIGNMENTS = 'FETCH_ASSIGNMENTS';
export const CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT';
export const EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT';
export const CLOSE_ASSIGNMENT = 'CLOSE_ASSIGNMENT';
export const REOPEN_ASSIGNMENT = 'REOPEN_ASSIGNMENT';
export const DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT';
export const SEARCH_ASSIGNMENT = 'SEARCH_ASSIGNMENT';
export const CHANGE_ASSIGNMENTS_SELECTED_SPACE =
  'CHANGE_ASSIGNMENTS_SELECTED_SPACE';
export const FETCH_SUBMISSIONS = 'FETCH_SUBMISSIONS';
